import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"

import DialogHeader from "../components/DialogHeader"
import SelectCandidateAutocomplete, {
  useSelectCandidateAutocompleteState,
} from "../components/SelectCandidateAutocomplete"

export default function CreateOfferSelectCandidateDialog({ open, onClose }) {
  const {
    searchText,
    setSearchText,
    selectedCandidate,
    setSelectedCandidate,
    clearSelectCandidateAutocomplete,
  } = useSelectCandidateAutocompleteState()

  function handleSelectButtonClicked() {
    onClose(selectedCandidate)
    clearSelectCandidateAutocomplete()
  }

  function handleSoftClose() {
    onClose()
    clearSelectCandidateAutocomplete()
  }

  return (
    <Dialog open={open} onClose={handleSoftClose} maxWidth="xs" fullWidth>
      <DialogHeader title="Select Candidate" onClose={handleSoftClose} />
      <DialogContent>
        <SelectCandidateAutocomplete
          searchText={searchText}
          setSearchText={setSearchText}
          selectedCandidate={selectedCandidate}
          setSelectedCandidate={setSelectedCandidate}
        />
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="primary" onClick={handleSoftClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          disabled={!selectedCandidate}
          onClick={handleSelectButtonClicked}
        >
          Select
        </Button>
      </DialogActions>
    </Dialog>
  )
}
